'use client';

import BaseError from '@hyex/modules/shared/BaseError';

export default BaseError;
